module.exports = __webpack_public_path__ + "img/logo-6.139fdb24.png";